import Global from '../store/global-selectors';
import { connect } from 'react-redux';
import get from 'lodash.get';
import * as Actions from '../store/orders/filtering/orders.filtering.actions';
import { DeleteFilterViewModal } from '../components/modals/delete-filterview-modal';

const mapStateToProps = (state) => {
  return {
    filterViewToDelete: Global.selectOrdersFilteringActiveFilterView(state),
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const closeModal = get(props, 'modalFrameworkMethods.closeModal');
  return {
    deleteFilterViewRequest: (filterViewToDelete) => {
      dispatch(Actions.deleteFilterViewRequest(filterViewToDelete));
      closeModal();
    },
  };
};

export const DeleteOrdersFilterviewModalContainer = connect(mapStateToProps, mapDispatchToProps)(DeleteFilterViewModal);
